/* eslint-disable @atlassian/tangerine/import/no-parent-imports */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import Lottie from 'lottie-react';

import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';

import { useThemeAnimation } from '../../../../common/ui/utils/use-theme-animation';
import { Skeleton } from '../skeleton';

const styles = cssMap({
	animationContainer: {
		display: 'none',
		'@media (min-width: 64rem)': {
			display: 'block',
			position: 'absolute',
			top: 0,
			left: 0,
			bottom: 0,
			right: 0,
			zIndex: 0,
			pointerEvents: 'none',
			width: '968px',
		},
	},
});

export type WelcomeAnimationProps = {
	onComplete?: () => void;
	onErrorLoadingAnimation?: (error: unknown) => void;
};

const loadLightAnimation = () => {
	return import(
		/* webpackChunkName: "@atlaskit-internal_welcome-twc-animation-light" */
		'../../../../ui/twc-xflow-modal/assets/welcome-animation-light.json'
	);
};

const loadDarkAnimation = () => {
	return import(
		/* webpackChunkName: "@atlaskit-internal_welcome-twc-animation-dark" */
		'../../../../ui/twc-xflow-modal/assets/welcome-animation-dark.json'
	);
};

export const WelcomeAnimation = ({
	onComplete,
	onErrorLoadingAnimation,
}: WelcomeAnimationProps): JSX.Element => {
	const animationData = useThemeAnimation(
		loadLightAnimation,
		loadDarkAnimation,
		onErrorLoadingAnimation,
	);

	return (
		<Box xcss={styles.animationContainer}>
			<Skeleton isLoading={!animationData}>
				<Lottie
					animationData={animationData}
					onComplete={onComplete}
					loop={false}
					autoplay={true}
				/>
			</Skeleton>
		</Box>
	);
};
